export var ENTITIES = 'entities';
export var LISTS = 'lists';
export var ITEMS = 'items';
export var DATA = 'data';
export var STATUS = 'status';
export var ERROR = 'errors';
export var SOURCE = 'source';
export var CONSUMERS = 'consumers';
export var RELATED = 'related';
export var PAGINATION = 'pagination';
export var META = 'meta';
export var ARGS = 'args';
export var ETAG = 'etag';
export var ITEM = 'item';
export var LIST = 'list';
export var STATUS_IDLE = 'idle';
export var STATUS_LOADING = 'loading';
export var STATUS_LOADED = 'loaded';
export var STATUS_FETCHING = 'fetching';
export var STATUS_REFRESHING = 'refreshing';
export var STATUS_UPDATING = 'updating';
export var STATUS_DELETING = 'deleting';
export var STATUS_ERROR = 'error';
export var SOURCE_ITEM = 'item';
export var SOURCE_LIST = 'list';
export var SOURCE_RELATED = 'related';
export var PAGINATION_CURRENT = 'currentPage';
export var PAGINATION_TOTAL = 'totalPages';
export var PAGINATION_ITEMS_PER_PAGE = 'itemsPerPage';
export var PAGINATION_TOTAL_ITEMS = 'totalItems';
export var PAGINATION_END_REACHED = 'endReached';
export var PAGINATION_LINKS = 'links';
export var PAGINATION_LINK_NEXT = 'next';